import * as React from "react";
const SvgFiRrY = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.633.226a1 1 0 0 0-1.407.142L12 10.421 3.774.367a1 1 0 0 0-1.549 1.265L11 12.357V23c.005 1.308 1.995 1.307 2 0V12.357l8.774-10.724a1 1 0 0 0-.14-1.407"
    />
  </svg>
);
export default SvgFiRrY;
